function Base64tool() {

}
Base64tool.prototype = {
        keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        b64EncodeUnicode: function (input) {
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;
            do {
                this.chr1 = input.charCodeAt(i++);
                this.chr2 = input.charCodeAt(i++);
                this.chr3 = input.charCodeAt(i++);
                this.enc1 = this.chr1 >> 2;
                this.enc2 = ((this.chr1 & 3) << 4) | (this.chr2 >> 4);
                this.enc3 = ((this.chr2 & 15) << 2) | (this.chr3 >> 6);
                this.enc4 = this.chr3 & 63;
                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }
                output = output + this.keyStr.charAt(enc1) + this.keyStr.charAt(this.enc2)
                    + this.keyStr.charAt(this.enc3) + this.keyStr.charAt(this.enc4);
                this.chr1 = this.chr2 = this.chr3 = "";
                this.enc1 = this.enc2 = this.enc3 = this.enc4 = "";
            } while (i < input.length);
            return output;
        },
        toHex: function (num) {
            return num < 16 ? "\\x0" + num.toString(16) : "\\x" + num.toString(16);
        },
        base64EncodeChars: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
        base64DecodeChars: new Array(
            -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
            -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
            -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63,
            52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1,
            -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
            15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1,
            -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
            41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1),
        base64decode: function (str) {
            var c1, c2, c3, c4;
            var i, len, out;

            len = str.length;
            i = 0;
            out = "";
            while (i < len) {
                /* c1 */
                do {
                    c1 = this.base64DecodeChars[str.charCodeAt(i++) & 0xff];
                } while (i < len && c1 == -1);
                if (c1 == -1)
                    break;

                /* c2 */
                do {
                    c2 = this.base64DecodeChars[str.charCodeAt(i++) & 0xff];
                } while (i < len && c2 == -1);
                if (c2 == -1)
                    break;

                out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));

                /* c3 */
                do {
                    c3 = str.charCodeAt(i++) & 0xff;
                    if (c3 == 61)
                        return out;
                    c3 = this.base64DecodeChars[c3];
                } while (i < len && c3 == -1);
                if (c3 == -1)
                    break;

                out += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));

                /* c4 */
                do {
                    c4 = str.charCodeAt(i++) & 0xff;
                    if (c4 == 61)
                        return out;
                    c4 = this.base64DecodeChars[c4];
                } while (i < len && c4 == -1);
                if (c4 == -1)
                    break;
                out += String.fromCharCode(((c3 & 0x03) << 6) | c4);
            }
            return out;
        },
        utf8to16: function (str) {
            var out, i, len, c;
            var char2, char3;

            out = "";
            len = str.length;
            i = 0;
            while (i < len) {
                c = str.charCodeAt(i++);
                switch (c >> 4) {
                    case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
                        // 0xxxxxxx
                        out += str.charAt(i - 1);
                        break;
                    case 12: case 13:
                        // 110x xxxx   10xx xxxx
                        char2 = str.charCodeAt(i++);
                        out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
                        break;
                    case 14:
                        // 1110 xxxx  10xx xxxx  10xx xxxx
                        char2 = str.charCodeAt(i++);
                        char3 = str.charCodeAt(i++);
                        out += String.fromCharCode(((c & 0x0F) << 12) |
                            ((char2 & 0x3F) << 6) |
                            ((char3 & 0x3F) << 0));
                        break;
                }
            }

            return out;
        },
        CharToHex: function (str) {
            var out, i, len, c, h;
            out = "";
            len = str.length;
            i = 0;
            while (i < len) {
                c = str.charCodeAt(i++);
                h = c.toString(16);
                if (h.length < 2)
                    h = "0" + h;

                out += "\\x" + h + " ";
                if (i > 0 && i % 8 == 0)
                    out += "\r\n";
            }
            return out;
        },

        //encode
        doEncode: function (str) {
            var k = '';
            if (str) {
                if (str.length > 2 && str.indexOf(" ") == -1) {
                    alert("data格式错误，字节请用空格隔开");
                    return false;
                }
                var arr = str.split(' ');

                for (var i in arr) {
                    k += '\\x' + arr[i].toLowerCase();
                }
                k = k.replace(/\\x([0-9a-f]{2})/g, function (_, pair) {
                    return String.fromCharCode(parseInt(pair, 16));
                })
                return b64EncodeUnicode(k);
            }
        },
        //decode
        doDecode: function (str) {
            return this.CharToHex(this.base64decode(str));
        }
}
function utils() { }
utils.prototype = {
    hex2int: function (hex) {
        var len = hex.length, a = new Array(len), code;
        for (var i = 0; i < len; i++) {
            code = hex.charCodeAt(i);
            if (48 <= code && code < 58) {
                code -= 48;
            } else {
                code = (code & 0xdf) - 65 + 10;
            }
            a[i] = code;
        }
        return a.reduce(function (acc, c) {
            acc = 16 * acc + c;
            return acc;
        }, 0);
    },
    int2hex: function (num, width) {
        var hex = "0123456789abcdef";
        var s = "";
        while (num) {
            s = hex.charAt(num % 16) + s;
            num = Math.floor(num / 16);
        }
        if (typeof width === "undefined" || width <= s.length) {
            return "0x" + s;
        }
        var delta = width - s.length;
        var padding = "";
        while (delta-- > 0) {
            padding += "0";
        }
        return "0x" + padding + s;
    },
}

export {
    Base64tool,
    utils
}